import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]
  static values = {
    contextType: String,
    contextId: Number,
    listId: String,
    docked: { type: Boolean, default: false },
    activeFilter: { type: String, default: "all" }
  }

  select(event) {
    const filter = event.currentTarget.dataset.filter
    if (filter === this.activeFilterValue) return

    this.activeFilterValue = filter
    this.updateTabs()
    this.loadFiltered()
  }

  updateTabs() {
    this.tabTargets.forEach(tab => {
      if (tab.dataset.filter === this.activeFilterValue) {
        tab.classList.add("bg-white", "text-sapphire", "shadow-sm", "font-medium")
        tab.classList.remove("text-gray-500", "hover:text-gray-700")
      } else {
        tab.classList.remove("bg-white", "text-sapphire", "shadow-sm", "font-medium")
        tab.classList.add("text-gray-500", "hover:text-gray-700")
      }
    })
  }

  loadFiltered() {
    const params = new URLSearchParams({
      context_type: this.contextTypeValue,
      context_id: this.contextIdValue,
      mention_filter: this.activeFilterValue,
      target_id: this.listIdValue,
      docked: this.dockedValue
    })

    fetch(`/activities/filtered_list?${params}`, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => response.text())
    .then(html => Turbo.renderStreamMessage(html))
  }
}
